import React, { Component } from 'react'
import { Table } from 'react-bootstrap'

class Publicaties extends Component {
    constructor(props) {
        super(props)
        this.getPublications = this.getPublications.bind(this)
        this.getTotalPoints = this.getTotalPoints.bind(this)
    }

    getPublications() {
        let data = this.props.data
        return data && data.length > 0 ? data.map((p, index) => {
            return <tr key={index}>
                <td>{p.quantity}</td>
                <td>{p.description}</td>
                <td>{p.year}</td>
                <td>{p.article}</td>
                <td>{p.points}</td>
            </tr>
        }) : null
    }

    getTotalPoints() {
        let data = this.props.data
        return data && data.length > 0 ?
            <tr>
                <td colSpan='4'><strong>Totaal ke´s</strong></td>
                <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
            </tr> : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Permanente publicaties" : "Publicaties"}</strong></h5>
                <Table responsive bordered className="publicaties">
                    <thead>
                        <tr>
                            <th>aantal pagina's</th>
                            <th>vakblad</th>
                            <th>jaartal</th>
                            <th>beschrijving</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getPublications()}
                        {this.getTotalPoints()}
                    </tbody>
                </Table>
            </div>)

    }
}

export default Publicaties;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Publicaties.js